
import { defineComponent, reactive } from 'vue'

import Modal from '@/common/components/UI/Modal/index.vue'
import FileReader from '@/common/components/UI/FileReader/index.vue'
import TheButton from '@/common/components/UI/TheButton/index.vue'

import useNotifications from '@/common/composable/useNotifications'

import useVuelidate from '@vuelidate/core'
import { required } from '@vuelidate/validators'

import tmsAPI from '@/new-services/tms.service'

export default defineComponent({
    components: {
        Modal,
        FileReader,
        TheButton,
    },
    emits: ['cancel', 'confirm'],
    setup(_, { emit }) {
        const notifications = useNotifications()

        const state = reactive({
            is_loading: false,
            file: [] as File[],
        })

        const state_form$ = useVuelidate(
            {
                file: { required },
            },
            state
        )

        const emitCancel = () => {
            if (state.is_loading) return
            emit('cancel')
        }

        const submitExcel = async () => {
            state_form$.value.$touch()
            if (state_form$.value.$invalid) return

            try {
                state.is_loading = true

                const form_data = new FormData()
                form_data.append('file', state.file[0])

                await tmsAPI.importExcelLoadStandard(form_data)

                notifications.notify({
                    type: 'success',
                    title: 'Нормы загруженности успешно импортированы!',
                })
                emit('confirm')
            } catch (error) {
                console.error(error)
                notifications.notifyError({
                    error,
                    title: 'Произошла ошибка',
                })
            } finally {
                state.is_loading = false
            }
        }

        return {
            state,
            state_form$,
            emitCancel,
            submitExcel,
        }
    },
})
